import React from 'react';
import ImageGallerystudycenter from '../components/ImageGallerystudycenter';
import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCSTUDY = () => {
  const studyBaseAmount = 100;

  const { stats, loading } = useStats();

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return 'Loading...';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        <section className="activities-details">
          <button 
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <div className="activity-intro">
            <h2>OUR ACTIVITIES</h2>
            <p>All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities</p>
          </div>

          <ImageGallerystudycenter />

          {/* IRC Study Centre */}
          <div className="activity-card">
            <div className="activity-header">
              <h3>IRC STUDY CENTRE (ISC)</h3>
            </div>
            <div className="activity-content">
              <p>Alhamdulillaah, with an aim to encourage education in our society, IRC runs 3 full-fledged Study Centers 2 for boys and 1 exclusively for girls in the city. The prominent features of this Study Center are:</p>

              <ul>
                <li>Completely free. No charges for any of the facilities provided</li>
                <li>Fully air-conditioned</li>
                <li>Uninterrupted high-speed Internet facility (for educational use only)</li>
                <li>Library with reference material for various competitive exams</li>
                <li>Exclusive reference library for Law students</li>
                <li>Open 7 days of the week (no holiday) from 6:00 am to 12:00 am (18 hours)</li>
                <li>Open for students from all faiths</li>
                <li>Seating capacity for Boys is 50 and Girls is 25</li>
              </ul>

              <div className="clinic-card">
                <h4>Centre - 1 - Roshan Gate</h4>
                <p><strong>Name:</strong> IRC Study Centre</p>
                <p><strong>For:</strong> Boys & Girls</p>
                <p><strong>Address:</strong> Sultan Complex, Shop No. 2,5 & 6 Near Shalimar Kitab Ghar, Roshan Gate, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Take A Video Tour:</strong> Click Here For Video</p>
                <p><strong>Date of Inauguration:</strong> 01-Jan-2016</p>
                <p><strong>No. Of Students:</strong> {formatNumber(stats.study_roshangate_students)} (till {formatDisplayDate(stats.study_roshangate_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('80-5555-7734')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    80-5555-7734
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Centre - 2 - Central Naka</h4>
                <p><strong>Name:</strong> IRC Study Centre</p>
                <p><strong>For:</strong> Boys</p>
                <p><strong>Address:</strong> 1st Floor, Islam Bates Masjid, Opp. Central Octroi Naka, Fish Market, Lane No. 19, Baijipura, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Take A Video Tour:</strong> Click Here For Video</p>
                <p><strong>Date of Inauguration:</strong> 10-Nov-2023</p>
                <p><strong>No. Of Students:</strong> {formatNumber(stats.study_centralnaka_students)} (till {formatDisplayDate(stats.study_centralnaka_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('80-5555-7734')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    80-5555-7734
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Centre - 3 - Ibrahim Park</h4>
                <p><strong>Name:</strong> IRC Study Centre</p>
                <p><strong>For:</strong> Boys & Girls</p>
                <p><strong>Address:</strong> Gut No. 33, Soniya Nagar, Ibrahim Park, Satara Deolai Parisar, Beed By Pass Road, Aurangabad. - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Community+Centre+Ibrahim+Park/@19.8516085,75.3061167,54m/data=!3m1!1e3!4m6!3m5!1s0x3bdb9939008d5771:0x78edc41cf90a24d5!8m2!3d19.8515497!4d75.3062471!16s%2Fg%2F11vsdq1xmd?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoKLDEwMDc5MjA3MUgBUAM%3D" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Take A Video Tour:</strong> Click Here For Video</p>
                <p><strong>Date of Inauguration:</strong> NA</p>
                <p><strong>No. Of Students:</strong> {formatNumber(stats.study_centralnaka_students)} (till {formatDisplayDate(stats.study_centralnaka_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('80-5555-7734')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    80-5555-7734
                  </span>
                </p>
              </div>
            </div>
            <IRCTVDonationCard
              title="IRC STUDY CENTRE (ISC)"
              baseAmount={studyBaseAmount}
              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality content and services to our community."
              amount="₹100000"
              purpose="Cause: IRC STUDY CENTRE (ISC)"
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCSTUDY;